import { Component } from "react"
import ReactDOM from "react-dom"

const modalRoot =
  typeof document !== `undefined` ? document.getElementById("portal") : null

class GalleryPortal extends Component {
  el: HTMLDivElement | null

  constructor(props) {
    super(props)
    // Use a ternary operator to make sure that the document object is defined
    this.el =
      typeof document !== `undefined` ? document.createElement("div") : null
  }

  componentDidMount = () => {
    if (modalRoot && this.el) modalRoot.appendChild(this.el)
  }

  componentWillUnmount = () => {
    if (modalRoot && this.el) modalRoot.removeChild(this.el)
  }

  render() {
    const { children } = this.props

    // Check that this.el is not null before using ReactDOM.createPortal
    if (this.el) {
      return ReactDOM.createPortal(children, this.el)
    } else {
      return null
    }
  }
}

export default GalleryPortal
